import { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const servicesData = [
  {
    id: 1,
    title: "META Ads",
    subtitle: "Facebook & Instagram Advertising",
    color: "from-blue-500 to-indigo-600",
    hoverColor: "from-blue-600 to-indigo-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
    ),
    description: "Targeted Facebook and Instagram advertising campaigns that drive real results and maximize your ROI with data-driven strategies.",
    features: [
      "Advanced Audience Targeting",
      "Creative Strategy & Design",
      "A/B Testing & Optimization",
      "Performance Analytics & Reporting",
      "Retargeting Campaigns",
      "Lead Generation Funnels"
    ],
    benefits: [
      "Reach 3+ billion active users",
      "Precise demographic targeting",
      "Cost-effective advertising",
      "Real-time performance tracking"
    ],
    pricing: "Starting at $999/month"
  },
  {
    id: 2,
    title: "Google Paid Ads",
    subtitle: "Search & Display Advertising",
    color: "from-green-500 to-emerald-600",
    hoverColor: "from-green-600 to-emerald-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    ),
    description: "High-intent traffic campaigns that maximize your budget and drive qualified leads to your business through strategic PPC management.",
    features: [
      "PPC Campaign Management",
      "Keyword Research & Strategy",
      "Landing Page Optimization",
      "Conversion Tracking Setup",
      "Google Shopping Ads",
      "Display Network Campaigns"
    ],
    benefits: [
      "Capture high-intent searches",
      "Pay only for results",
      "Instant visibility boost",
      "Measurable ROI tracking"
    ],
    pricing: "Starting at $1,299/month"
  },
  {
    id: 3,
    title: "Software Development",
    subtitle: "Custom Software Solutions",
    color: "from-cyan-500 to-blue-600",
    hoverColor: "from-cyan-600 to-blue-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
    ),
    description: "Build powerful custom software solutions tailored to your business needs with cutting-edge technologies and scalable architecture.",
    features: [
      "Custom Web Applications",
      "Enterprise Software Solutions",
      "API Development & Integration",
      "Cloud-Based Solutions",
      "Database Design & Optimization",
      "Maintenance & Support"
    ],
    benefits: [
      "Tailored to your workflow",
      "Scalable architecture",
      "Modern tech stack",
      "Ongoing technical support"
    ],
    pricing: "Starting at $5,999/project"
  },
  {
    id: 4,
    title: "Mobile App Development",
    subtitle: "iOS & Android Applications",
    color: "from-purple-500 to-pink-600",
    hoverColor: "from-purple-600 to-pink-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
    ),
    description: "Create stunning mobile applications for iOS and Android that engage users and drive business growth with intuitive design.",
    features: [
      "Native iOS & Android Apps",
      "Cross-Platform Development",
      "UI/UX Design",
      "App Store Optimization",
      "Push Notifications",
      "Analytics Integration"
    ],
    benefits: [
      "Reach mobile-first audience",
      "Native performance",
      "App store presence",
      "Enhanced user engagement"
    ],
    pricing: "Starting at $8,999/project"
  },
  {
    id: 5,
    title: "AI Solutions",
    subtitle: "Intelligent Automation & Analytics",
    color: "from-rose-500 to-orange-600",
    hoverColor: "from-rose-600 to-orange-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    ),
    description: "Leverage cutting-edge AI and machine learning to automate processes, gain insights, and build intelligent solutions for your business.",
    features: [
      "AI-Powered Chatbots",
      "Machine Learning Models",
      "Predictive Analytics",
      "Natural Language Processing",
      "Computer Vision Solutions",
      "AI Integration & Consulting"
    ],
    benefits: [
      "24/7 automated operations",
      "Data-driven insights",
      "Reduced operational costs",
      "Competitive advantage"
    ],
    pricing: "Starting at $3,999/project"
  },
  {
    id: 6,
    title: "SEO Optimization",
    subtitle: "Organic Search Growth",
    color: "from-green-500 to-teal-600",
    hoverColor: "from-green-600 to-teal-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    ),
    description: "Improve your search rankings with our comprehensive SEO strategies that deliver long-term growth and sustainable organic traffic.",
    features: [
      "Technical SEO Audit",
      "Content Strategy & Creation",
      "Link Building Campaigns",
      "Local SEO Optimization",
      "On-Page SEO",
      "Competitor Analysis"
    ],
    benefits: [
      "Long-term organic growth",
      "Increased brand authority",
      "Higher quality traffic",
      "Better user experience"
    ],
    pricing: "Starting at $1,499/month"
  },
  {
    id: 7,
    title: "Content Marketing",
    subtitle: "Strategic Content Creation",
    color: "from-orange-500 to-amber-600",
    hoverColor: "from-orange-600 to-amber-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    ),
    description: "Engage your audience with compelling content that tells your brand story and drives meaningful connections with your customers.",
    features: [
      "Content Strategy Development",
      "Blog Writing & Management",
      "Video Content Production",
      "Infographic Design",
      "Email Marketing Campaigns",
      "Social Media Content"
    ],
    benefits: [
      "Build brand authority",
      "Engage target audience",
      "Improve SEO rankings",
      "Generate quality leads"
    ],
    pricing: "Starting at $899/month"
  },
  {
    id: 8,
    title: "Social Media Management",
    subtitle: "Complete Social Presence",
    color: "from-indigo-500 to-purple-600",
    hoverColor: "from-indigo-600 to-purple-700",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
    ),
    description: "Build and maintain a strong social media presence across all platforms with consistent, engaging content and community management.",
    features: [
      "Multi-Platform Management",
      "Content Calendar Planning",
      "Community Engagement",
      "Influencer Partnerships",
      "Social Listening",
      "Performance Reporting"
    ],
    benefits: [
      "Consistent brand voice",
      "Increased engagement",
      "Community building",
      "Real-time customer support"
    ],
    pricing: "Starting at $799/month"
  }
];

const ServicesPage = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <Navbar />
      
      {/* Hero Section */}
      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-100 border border-indigo-200 mb-6">
            <span className="w-2 h-2 bg-indigo-600 rounded-full mr-2 animate-pulse"></span>
            <span className="text-sm font-medium text-indigo-700 uppercase tracking-wider">
              Our Services
            </span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-gray-900 to-indigo-900 bg-clip-text text-transparent mb-6">
            Comprehensive Digital Marketing
          </h1>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-8">
            Solutions for Your Business
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Specializing in META Ads, Google Ads, custom software development, mobile apps, and AI solutions. 
            We deliver comprehensive digital services designed to accelerate your growth and maximize ROI.
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <div
              key={service.id}
              className={`group relative transition-all duration-700 transform ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onClick={() => setSelectedService(service)}
            >
              <div className="relative bg-white rounded-3xl p-8 h-full border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-500 group-hover:scale-105 cursor-pointer overflow-hidden">
                
                {/* Gradient Overlay */}
                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
                
                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`p-4 rounded-2xl bg-gradient-to-r ${service.color} shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110 inline-block mb-6`}>
                    <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      {service.icon}
                    </svg>
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm text-indigo-600 font-medium mb-4">
                    {service.subtitle}
                  </p>
                  
                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {service.description}
                  </p>

                  {/* Features Preview */}
                  <div className="space-y-2 mb-6">
                    {service.features.slice(0, 3).map((feature, idx) => (
                      <div key={idx} className="flex items-center text-gray-500">
                        <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${service.color} mr-3`}></div>
                        <span className="text-sm">{feature}</span>
                      </div>
                    ))}
                    {service.features.length > 3 && (
                      <p className="text-sm text-indigo-600 font-medium ml-5">
                        +{service.features.length - 3} more features
                      </p>
                    )}
                  </div>

                  {/* Pricing */}
                  <div className="pt-4 border-t border-gray-200">
                    <p className="text-lg font-bold text-gray-900">{service.pricing}</p>
                  </div>

                  {/* Learn More Arrow */}
                  <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transform translate-x-4 group-hover:translate-x-0 transition-all duration-500">
                    <div className={`p-2 rounded-full bg-gradient-to-r ${service.color} text-white`}>
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Glow Effect */}
                <div className={`absolute -inset-1 bg-gradient-to-r ${service.color} rounded-3xl blur opacity-0 group-hover:opacity-20 transition-opacity duration-500 -z-10`}></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Service Detail Modal */}
      {selectedService && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setSelectedService(null)}>
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto p-8 relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedService(null)}
              className="absolute top-6 right-6 p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              <svg className="h-6 w-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className={`p-4 rounded-2xl bg-gradient-to-r ${selectedService.color} shadow-lg inline-block mb-6`}>
              <svg className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {selectedService.icon}
              </svg>
            </div>

            <h2 className="text-4xl font-bold text-gray-900 mb-2">{selectedService.title}</h2>
            <p className="text-lg text-indigo-600 font-medium mb-6">{selectedService.subtitle}</p>
            
            <p className="text-gray-600 text-lg leading-relaxed mb-8">{selectedService.description}</p>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Features Included</h3>
                <div className="space-y-3">
                  {selectedService.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start">
                      <div className={`w-6 h-6 rounded-full bg-gradient-to-r ${selectedService.color} flex items-center justify-center mr-3 mt-0.5 flex-shrink-0`}>
                        <svg className="h-4 w-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Key Benefits</h3>
                <div className="space-y-3">
                  {selectedService.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-start">
                      <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${selectedService.color} mr-3 mt-2`}></div>
                      <span className="text-gray-700">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl p-6 mb-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">Investment</p>
                  <p className="text-3xl font-bold text-gray-900">{selectedService.pricing}</p>
                </div>
                <button className={`px-8 py-4 rounded-xl bg-gradient-to-r ${selectedService.color} text-white font-semibold hover:shadow-lg transition-all duration-300 transform hover:scale-105`}>
                  Get Started
                </button>
              </div>
            </div>

            <p className="text-sm text-gray-500 text-center">
              Custom packages available. Contact us for a personalized quote.
            </p>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 py-20">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Transform Your Digital Presence?
          </h2>
          <p className="text-xl text-indigo-100 mb-8">
            Let's discuss which services are right for your business goals.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-indigo-600 px-8 py-4 rounded-xl font-semibold hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
              Schedule Consultation
            </button>
            <button className="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-indigo-600 transition-all duration-300 transform hover:scale-105">
              View Case Studies
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ServicesPage;
